module.exports = __webpack_public_path__ + "img/img09.966bb62c.svg";